import classNames from 'classnames';
import React, { FC, MouseEvent } from 'react';
import OrganizationLink from 'src/common/OrganizationLink';
import { Nullable } from 'src/types/nullable.type';
import { trackSegmentEvent } from 'src/utils/segment';

interface PageSidebarItemProps {
  isActive: boolean;
  target: string;
  renderBadge?: Nullable<JSX.Element>;
  trackingName: string;
  onClick?: (e: MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
}

export const PageSidebarItemClasses =
  'flex rounded-lg items-center transition-colors hover:bg-bedrock-light-gray text-bedrock-black p-2';

export const PageSidebarItem: FC<PageSidebarItemProps> = ({
  isActive,
  target,
  children,
  className,
  renderBadge = null,
  onClick,
  trackingName,
}) => (
  <OrganizationLink
    to={target}
    className={classNames(
      PageSidebarItemClasses,
      {
        'bg-bedrock-light-gray': isActive,
        'bg-bedrock-white': !isActive,
      },
      className
    )}
    onClick={(event: MouseEvent<HTMLButtonElement, MouseEvent>) => {
      trackSegmentEvent('Sidebar Item Clicked', {
        item: trackingName,
      });
      if (onClick) {
        onClick(event);
      }
    }}
  >
    <div className='flex items-center shrink-0 space-x-sm'>{children}</div>
    {renderBadge}
  </OrganizationLink>
);
